var _g, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleBlocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3833_2685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9382 14.6505C24.5246 14.0647 25.343 13.9325 25.7661 14.3552C26.1893 14.7779 26.0569 15.5954 25.4705 16.1812L16.2685 25.3736C15.6821 25.9593 14.8638 26.0916 14.4406 25.6689C14.0175 25.2462 14.1499 24.4287 14.7363 23.8429L23.9382 14.6505Z",
    fill: "#D91F05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0618 14.7443C15.4754 14.1585 14.6774 14.0058 14.2795 14.4034C13.8815 14.8009 14.0343 15.598 14.6207 16.1838L23.8227 25.3762C24.4091 25.962 25.207 26.1146 25.605 25.7171C26.0029 25.3196 25.8501 24.5224 25.2637 23.9366L16.0618 14.7443Z",
    fill: "#D91F05"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#D91F05"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3833_2685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white",
    transform: "translate(12 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBlocked);
export default __webpack_public_path__ + "static/media/circleBlocked.5b4ed9e0a1d1d1723cf20b9562e1ae99.svg";
export { ForwardRef as ReactComponent };